import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/checkout';
interface CTAButtonProps {
  label: string;
  subline?: string;
  id?: string;
  variant?: 'gold' | 'navy';
  className?: string;
}
export function CTAButton({
  label,
  subline,
  id,
  variant = 'gold',
  className = ''
}: CTAButtonProps) {
  const isGold = variant === 'gold';
  return <div id={id} className={`w-full ${className}`} data-id="element-104" data-mp="2ty1o7ppov3pk">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={['group flex w-full items-center justify-center gap-2.5 rounded-2xl px-5 py-4 text-center', 'text-[15px] font-extrabold uppercase leading-tight tracking-tight sm:text-lg', 'shadow-cta transition-[transform,background-color,box-shadow] duration-150 ease-out', 'hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.99]', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-500', isGold ? 'bg-gold-500 text-navy-900 hover:bg-gold-400' : 'bg-navy-800 text-cream-100 hover:bg-navy-700'].join(' ')} data-id="element-105" data-mp="2p0jevy7remh1">
        {isGold ? <CheckCircle2Icon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-106" data-mp="1ibnxndm7mlyc" /> : null}
        <span className="max-w-[15ch] sm:max-w-none" data-id="element-107" data-mp="1n6l2s9gdcb5y">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-108" data-mp="1s6pivydd73vn" />
      </a>
      {subline ? <p className="mt-3 text-center text-[13px] font-medium leading-relaxed text-navy-700/75" data-id="element-109" data-mp="211dppsyl8tmk">
          {subline}
        </p> : null}
    </div>;
}